import { useNavigate } from "react-router-dom";

export const consumirApi = async ({ url, method = 'GET', body = null, headers = {} }) => {
  try {
    const options = {
      method,
      headers: {
        'Content-Type': 'application/json',
        ...headers
      },
    };

    if (body && ['POST', 'PUT', 'PATCH'].includes(method.toUpperCase())) {
      options.body = JSON.stringify(body);
    }

    const response = await fetch(url, options);

    let data;
    try {
      data = await response.json(); // intentamos parsear JSON aunque sea error
    } catch {
      data = null; // si no es JSON, lo dejamos null
    }

    if (!response.ok) {
      // Retornamos mensaje del servidor si existe
      const message = data?.detail || data?.message || response.statusText;
      return { success: false, status: response.status, message };
    }

    return { success: true, data };

  } catch (error) {
    return { success: false, message: error.message };
  }
};

export const consumirApiJwt = async ({ url, method = 'GET', body = null, token = null, navigate }) => {
  try {
    const headers = { 'Content-Type': 'application/json' };

    if (token) headers['Authorization'] = `Bearer ${token}`;

    const options = { method, headers };

    if (body && ['POST', 'PUT', 'PATCH'].includes(method.toUpperCase())) {
      options.body = JSON.stringify(body);
    }

    const response = await fetch(url, options);

    const data = await response.json(); // primero parseamos el body

    if (response.status === 401) {
      // Token inválido o expirado
      localStorage.removeItem('token');
      if (navigate) navigate('/login'); // o donde esté tu login
      return { success: false, message: 'Sesión expirada, por favor inicia sesión de nuevo' };
    }

    if (!response.ok) {
      // Usamos el mensaje que venga del backend si existe
      const message = data?.message || data?.detail || `Error: ${response.status} ${response.statusText}`;
      return { success: false, message };
    }

    // ✅ éxito
    return { success: true, data };

  } catch (error) {
    // error de conexión u otro
    return { success: false, message: error.message };
  }
};

